export default {
  lcp: {
    create_user_username_info:
      "The username will be set to the user's email address. If no email is provided, a unique username will be generated.",
    gar_user_not_permitted: 'You cannot change GAR user. Contact your employer!',
    let_me_choose_username_password: 'Let me choose the username and password',
    not_permitted: 'Not permitted',
    only_admin_or_employee_permitted: 'Only administrator or teachers are permitted',
    only_admin_permitted: 'Only administrators are permitted',
    only_customer_support_permitted: 'Only Customer Support can edit the field',
    qr_logins_not_allowed_in_school: 'Login with QR Code is not allowed in the school',
    qr_logins_not_allowed_in_student_school: "Login with QR Code is not allowed in the student's school",
    require_mfa: 'You must login with MFA (BankId or SMS)',
    unsupported_property_for_employees: 'Unsupported property for employees',
    user_management_disabled: 'User management disabled',
    user_synced: 'User is synced',
    value_synced: 'Value is synced',
    create_new_user: 'Create a new user',
  },
};
